class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    const facetForm = this.querySelector('form');

    facetForm.addEventListener('submit', this.onFormSubmit.bind(this));

    const clearButton = this.querySelector('.filter-footer__clear');
    if (clearButton) {
      clearButton.addEventListener('click', this.onClearFilters.bind(this));
    }

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', this.onKeyUpEscape.bind(this));

    const clearAllButtons = this.querySelectorAll('.clear-all-filters, .active-facets__button-remove');
    clearAllButtons.forEach(button => {
      button.addEventListener('click', this.onClearAllFilters.bind(this));
    });
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static scrollToProductGrid(productGrid) {
    // Sticky filter height'ını hesapla
    const stickyFilter = document.querySelector('.collection-filter');
    const header = document.querySelector('.header');

    let offsetTop = 20; // Default offset

    // Header height'ını ekle
    if (header) {
      offsetTop += header.offsetHeight;
    }

    // Sticky filter varsa onun height'ını da hesaba kat
    if (stickyFilter) {
      offsetTop += 20; // Extra space for better UX
    }

    // Product grid'in pozisyonunu hesapla
    const gridRect = productGrid.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const targetPosition = gridRect.top + scrollTop - offsetTop;

    // Smooth scroll to target position
    window.scrollTo({
      top: Math.max(0, targetPosition),
      behavior: 'smooth'
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');

    // Normod product grid'i bul ve loading state ekle
    const productGrid = document.querySelector('[data-products-grid]') ||
                       document.querySelector('.normod-collection-grid-view') ||
                       document.querySelector('.product-list--collection');

    if (productGrid) {
      productGrid.classList.add('is-loading');
    }

    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html, !!event);
        FacetFiltersForm.renderProductCount(html);
        FacetFiltersForm.renderNavProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html, !!event);
    FacetFiltersForm.renderProductCount(html);
    FacetFiltersForm.renderNavProductCount(html);
  }

  static renderProductGridContainer(html, shouldScroll = false) {
    // Normod product grid'i bul
    const productGridSelector = '[data-products-grid], .normod-collection-grid-view, .product-list--collection';
    const currentProductGrid = document.querySelector(productGridSelector);

    if (currentProductGrid) {
      const newDocument = new DOMParser().parseFromString(html, 'text/html');
      const newProductGrid = newDocument.querySelector(productGridSelector);

      if (newProductGrid) {
        currentProductGrid.innerHTML = newProductGrid.innerHTML;
        currentProductGrid.classList.remove('is-loading');

        // Auto-scroll to product grid after content is updated (only when filtering)
        if (shouldScroll) {
          setTimeout(() => {
            FacetFiltersForm.scrollToProductGrid(currentProductGrid);
          }, 100);
        }
      }
    }

    // Pagination güncelle
    FacetFiltersForm.renderPagination(html);
  }

  static renderProductCount(html) {
    const countSelectors = [
      '#ProductCount',
      '#ProductCountDesktop',
      '.collection-product-count',
      '.collection__products-count'
    ];

    const newDocument = new DOMParser().parseFromString(html, 'text/html');

    countSelectors.forEach(selector => {
      const container = document.querySelector(selector);
      const newCount = newDocument.querySelector(selector);

      if (container && newCount) {
        container.innerHTML = newCount.innerHTML;
        container.classList.remove('loading');
      }
    });
  }

  static renderNavProductCount(html) {
    var newDocument = new DOMParser().parseFromString(html, 'text/html');
    var newCount = newDocument.querySelector('[data-products-count]');
    var currentCount = document.querySelector('[data-products-count]');
    if (newCount && currentCount) {
      currentCount.textContent = newCount.textContent;
    }
  }

  static renderPagination(html) {
    const paginationSelectors = [
      '.pagination',
      '.collection__pagination',
      '[data-pagination]'
    ];

    const newDocument = new DOMParser().parseFromString(html, 'text/html');

    paginationSelectors.forEach(selector => {
      const currentPagination = document.querySelector(selector);
      const newPagination = newDocument.querySelector(selector);

      if (currentPagination && newPagination) {
        currentPagination.innerHTML = newPagination.innerHTML;
      } else if (currentPagination && !newPagination) {
        // Eğer filtreleme sonucu pagination kalmadıysa (tek sayfa), pagination'ı gizle
        currentPagination.style.display = 'none';
      } else if (!currentPagination && newPagination) {
        // Eğer önceden pagination yoktu ama şimdi var ise, ekle
        const productGrid = document.querySelector('[data-products-grid]') ||
                           document.querySelector('.normod-collection-grid-view');
        if (productGrid && productGrid.parentNode) {
          const paginationElement = newPagination.cloneNode(true);
          productGrid.parentNode.insertBefore(paginationElement, productGrid.nextSibling);
        }
      }
    });

    // Pagination yoksa, mevcut pagination'ı göster
    const currentPagination = document.querySelector('.pagination, .collection__pagination, [data-pagination]');
    if (currentPagination && currentPagination.style.display === 'none') {
      const newPagination = newDocument.querySelector('.pagination, .collection__pagination, [data-pagination]');
      if (newPagination) {
        currentPagination.style.display = '';
      }
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetsWrapperDesktop .js-filter, #FacetsWrapperMobile .js-filter, #FacetsWrapperDrawer .js-filter, .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      const currentFilter = document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`);
      if (currentFilter) {
        currentFilter.innerHTML = element.innerHTML;
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop', '.active-filters'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      const currentElement = document.querySelector(selector);
      if (!activeFacetsElement || !currentElement) return;
      currentElement.innerHTML = activeFacetsElement.innerHTML;
    });

    // Re-attach event listeners to clear all buttons after innerHTML change
    FacetFiltersForm.attachClearAllListeners();
    FacetFiltersForm.toggleActiveFacets(false);
  }

  static attachClearAllListeners() {
    const facetForm = document.querySelector('facet-filters-form');
    if (!facetForm) return;

    const clearAllButtons = document.querySelectorAll('.clear-all-filters, .active-facets__button-remove');
    clearAllButtons.forEach(button => {
      // Remove existing listener to avoid duplicates
      button.replaceWith(button.cloneNode(true));
    });

    // Re-attach listeners
    const newClearAllButtons = document.querySelectorAll('.clear-all-filters, .active-facets__button-remove');
    newClearAllButtons.forEach(button => {
      button.addEventListener('click', facetForm.onClearAllFilters.bind(facetForm));
    });
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      const newElement = html.querySelector(selector);
      const currentElement = document.querySelector(selector);
      if (!newElement || !currentElement) return;
      currentElement.innerHTML = newElement.innerHTML;
    });

    // Update sort selects specifically
    FacetFiltersForm.renderSortSelects(html);

    // Remove loading states
    const facetsWrapper = document.getElementById('FacetsWrapperDesktop');
    if (facetsWrapper) facetsWrapper.classList.remove('loading');
  }

  static renderSortSelects(html) {
    const sortSelectors = ['#sort-by', '#sort-by-mobile', '[data-sort-select]'];
    const newDocument = new DOMParser().parseFromString(html, 'text/html');

    sortSelectors.forEach(selector => {
      const currentSelect = document.querySelector(selector);
      const newSelect = newDocument.querySelector(selector);

      if (currentSelect && newSelect) {
        // Seçili değeri koru
        const selectedValue = newSelect.value;
        currentSelect.value = selectedValue;

        // Tüm option'ları güncelle
        currentSelect.innerHTML = newSelect.innerHTML;
        currentSelect.value = selectedValue;
      }
    });
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target
        .querySelector('.facets__summary')
        .setAttribute('aria-expanded', source.querySelector('.facets__summary').getAttribute('aria-expanded'));
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      '',
      `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`
    );
  }

  static getSections() {
    // Normod product grid'i bul
    const productGrid = document.querySelector('[data-products-grid]') ||
                       document.querySelector('.normod-collection-grid-view') ||
                       document.querySelector('.product-list--collection');

    if (productGrid) {
      // Section ID'sini data attribute'dan veya parent'tan al
      const sectionElement = productGrid.closest('[data-section-id]') ||
                             document.querySelector('[data-section-type="collection"]');

      const sectionId = sectionElement?.dataset.sectionId ||
                       sectionElement?.id ||
                       'collection-template';

      return [{ section: sectionId }];
    }

    return [{ section: 'collection-template' }];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onFormSubmit(event) {
    event.preventDefault();
    const form = event.target;
    const formData = new FormData(form);
    const searchParams = new URLSearchParams(formData).toString();
    FacetFiltersForm.renderPage(searchParams, event);
    FacetFiltersForm.updateFilterButtonCount(form);
    FacetFiltersForm.closeFilterDrawer();
  }

  onClearFilters(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    if (form) {
      form.querySelectorAll('input[type="checkbox"]').forEach(function(cb) { cb.checked = false; });
      form.querySelectorAll('input[type="number"]').forEach(function(input) { input.value = ''; });
      form.querySelectorAll('input[type="radio"]:not([name="sort_by"])').forEach(function(radio) { radio.checked = false; });
    }
    var url = event.currentTarget.getAttribute('href');
    var searchParams = url.indexOf('?') === -1 ? '' : url.slice(url.indexOf('?') + 1);
    FacetFiltersForm.renderPage(searchParams, event);
    FacetFiltersForm.updateFilterButtonCount(form);
    FacetFiltersForm.closeFilterDrawer();
  }

  static updateFilterButtonCount(form) {
    var count = 0;
    if (form) {
      count = form.querySelectorAll('.filter-checkbox:checked, .facets__checkbox:checked').length;
      var priceMin = form.querySelector('[data-price-min]');
      var priceMax = form.querySelector('[data-price-max]');
      if (priceMin && priceMin.value && priceMin.value !== '0') count++;
      if (priceMax && priceMax.value) count++;
    }
    var btnText = document.querySelector('[data-filter-btn-text]');
    if (btnText) {
      btnText.textContent = count > 0 ? 'Filtrele & Sırala (' + count + ')' : 'Filtrele & Sırala';
    }
    var btn = document.querySelector('[data-filter-count]');
    if (btn) btn.setAttribute('data-filter-count', count);
  }

  static closeFilterDrawer() {
    var drawer = document.getElementById('normod-filter-drawer');
    if (drawer) {
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('no-mobile-scroll');
      document.querySelectorAll('[data-action="open-drawer"][aria-controls="normod-filter-drawer"]').forEach(function(btn) {
        btn.setAttribute('aria-expanded', 'false');
      });
    }

    var collectionFilter = document.querySelector('.collection-filter');
    if (collectionFilter && collectionFilter.classList.contains('is-open')) {
      collectionFilter.classList.remove('is-open');
      var backdrop = document.querySelector('.drawer-backdrop');
      if (backdrop) backdrop.classList.remove('is-visible');
      setTimeout(function() {
        collectionFilter.classList.remove('is-mobile-drawer');
        document.body.style.overflow = '';
      }, 400);
    }
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData).toString();
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }

  onClearAllFilters(event) {
    event.preventDefault();

    // Clear all form inputs
    const form = this.querySelector('form');
    if (form) {
      // Clear all checkboxes
      form.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
        checkbox.checked = false;
      });

      // Clear all radio buttons (except sort_by)
      form.querySelectorAll('input[type="radio"]:not([name="sort_by"])').forEach(radio => {
        radio.checked = false;
      });

      // Reset price range inputs
      form.querySelectorAll('input[type="number"]').forEach(input => {
        input.value = '';
      });

      // Reset price range sliders
      form.querySelectorAll('input[type="range"]').forEach(slider => {
        if (slider.dataset.minRange !== undefined) {
          slider.value = slider.min;
        } else if (slider.dataset.maxRange !== undefined) {
          slider.value = slider.max;
        }
      });

      // Update price range slider progress
      const priceRanges = form.querySelectorAll('price-range');
      priceRanges.forEach(priceRange => {
        if (priceRange.updateSliderProgress) {
          priceRange.updateSliderProgress();
        }
      });
    }

    // Get the clear all URL from the event target
    const clearUrl = event.currentTarget.href;
    const url = clearUrl.indexOf('?') == -1 ? '' : clearUrl.slice(clearUrl.indexOf('?') + 1);

    // Render the page with cleared filters
    FacetFiltersForm.renderPage(url);
  }

  onKeyUpEscape(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement.removeAttribute('open');
    openDetailsElement.querySelector('summary').setAttribute('aria-expanded', false);
  }

  filterData = [];
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();

    // Number input'ları için event listener'lar
    this.querySelectorAll('input[type="number"]').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('input', this.onNumberInputChange.bind(this));
    });

    // Range slider input'ları için event listener'lar
    this.querySelectorAll('input[type="range"]').forEach((element) => {
      element.addEventListener('input', this.onSliderChange.bind(this));
    });

    this.setMinAndMaxValues();
    this.initializeSlider();
  }

  initializeSlider() {
    if (this.classList.contains('facets__price--slider')) {
      this.updateSliderProgress();
    }
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onNumberInputChange(event) {
    const input = event.currentTarget;
    this.adjustToValidValues(input);
    this.updateSliderFromInputs();
  }

  onSliderChange(event) {
    const slider = event.currentTarget;
    this.updateInputsFromSliders(slider);
    this.updateSliderProgress();
  }

  updateSliderFromInputs() {
    if (!this.classList.contains('facets__price--slider')) return;

    const minInput = this.querySelector('[data-price-min]');
    const maxInput = this.querySelector('[data-price-max]');
    const minSlider = this.querySelector('[data-min-range]');
    const maxSlider = this.querySelector('[data-max-range]');

    if (minInput && minSlider) {
      minSlider.value = minInput.value || 0;
    }
    if (maxInput && maxSlider) {
      maxSlider.value = maxInput.value || maxSlider.max;
    }

    this.updateSliderProgress();
  }

  updateInputsFromSliders(activeSlider) {
    if (!this.classList.contains('facets__price--slider')) return;

    const minInput = this.querySelector('[data-price-min]');
    const maxInput = this.querySelector('[data-price-max]');
    const minSlider = this.querySelector('[data-min-range]');
    const maxSlider = this.querySelector('[data-max-range]');

    if (parseInt(minSlider.value) >= parseInt(maxSlider.value)) {
      if (activeSlider === minSlider) {
        maxSlider.value = parseInt(minSlider.value) + 1;
      } else {
        minSlider.value = parseInt(maxSlider.value) - 1;
      }
    }

    if (minInput && minSlider) {
      minInput.value = minSlider.value;
    }
    if (maxInput && maxSlider) {
      maxInput.value = maxSlider.value;
    }

    // Form submit et
    this.triggerFormChange();
  }

  updateSliderProgress() {
    if (!this.classList.contains('facets__price--slider')) return;

    const minSlider = this.querySelector('[data-min-range]');
    const maxSlider = this.querySelector('[data-max-range]');
    const progress = this.querySelector('[data-progress]');

    if (!minSlider || !maxSlider || !progress) return;

    const min = parseInt(minSlider.min);
    const max = parseInt(minSlider.max);
    const minVal = parseInt(minSlider.value);
    const maxVal = parseInt(maxSlider.value);

    const minPercent = ((minVal - min) / (max - min)) * 100;
    const maxPercent = ((maxVal - min) / (max - min)) * 100;

    progress.style.left = minPercent + '%';
    progress.style.width = (maxPercent - minPercent) + '%';
  }

  triggerFormChange() {
    // Dawn'ın form değişiklik event'ini tetikle
    const form = this.closest('form');
    if (form) {
      const event = new Event('input', { bubbles: true });
      form.dispatchEvent(event);
    }
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input[type="number"]');
    const minInput = inputs[0];
    const maxInput = inputs[1];

    if (!minInput || !maxInput) return;

    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

class ShowMoreButton extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector('button');
    button.addEventListener('click', (event) => {
      this.expandShowMore(event);
      const nextElementToFocus = event.target.closest('.parent-display').querySelector('.show-more-item');
      if (nextElementToFocus && !nextElementToFocus.classList.contains('hidden')) {
        nextElementToFocus.querySelector('input').focus();
      }
    });
  }

  expandShowMore(event) {
    const parentDisplay = event.target.closest('[id^="Show-More-"]').closest('.parent-display');
    if (parentDisplay) {
      parentDisplay.querySelectorAll('.show-more-item').forEach((element) => element.classList.remove('hidden'));

      const parentDisplayContainer = event.target.closest('.parent-display');
      if (parentDisplayContainer) {
        const showMoreItem = parentDisplayContainer.querySelector('.show-more-item');
        const showLessItem = parentDisplayContainer.querySelector('.show-less-item');
        if (showMoreItem) showMoreItem.classList.add('hidden');
        if (showLessItem) showLessItem.classList.remove('hidden');
      }
    }

    // Toggle button text
    const showMoreLabel = event.target.querySelector('.label-show-more');
    const showLessLabel = event.target.querySelector('.label-show-less');
    if (showMoreLabel && showLessLabel) {
      showMoreLabel.classList.toggle('hidden');
      showLessLabel.classList.toggle('hidden');
    }
  }
}

customElements.define('show-more-button', ShowMoreButton);

class FacetSortForm extends HTMLElement {
  constructor() {
    super();
    this.onSortChange = this.onSortChange.bind(this);
    this.querySelector('select').addEventListener('change', this.onSortChange);
  }

  onSortChange(event) {
    const sortValue = event.target.value;
    const url = new URL(window.location);

    if (sortValue) {
      url.searchParams.set('sort_by', sortValue);
    } else {
      url.searchParams.delete('sort_by');
    }

    // Dawn facet sistemini kullanarak page render et
    const searchParams = url.searchParams.toString();
    FacetFiltersForm.renderPage(searchParams, event);
  }
}

customElements.define('facet-sort-form', FacetSortForm);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

// Use event delegation for pagination links - more reliable
document.addEventListener('click', function(e) {
  console.log('Document click detected, target:', e.target);

  // Check if clicked element is a pagination link
  const paginationLink = e.target.closest('.pagination a, .collection__pagination a, [data-pagination] a');
  console.log('Pagination link found:', paginationLink);

  if (paginationLink) {
    console.log('Pagination link href:', paginationLink.href);
    console.log('Pagination link data-page:', paginationLink.getAttribute('data-page'));
    console.log('Has data-page attribute:', paginationLink.hasAttribute('data-page'));

    if (paginationLink.hasAttribute('data-page')) {
      console.log('*** PREVENTING DEFAULT PAGINATION NAVIGATION ***');
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      // Get current search params from the facet form instead of URL
      const facetForm = document.querySelector('facet-filters-form form');
      const pageParam = paginationLink.getAttribute('data-page');

      let searchParams = '';

      if (facetForm) {
        console.log('Using form data for search params');
        // Create form data from current form state
        const formData = new FormData(facetForm);
        const urlParams = new URLSearchParams(formData);

        // Remove existing page parameter if any
        urlParams.delete('page');

        // Add the new page parameter
        if (pageParam) {
          urlParams.append('page', pageParam);
        }

        searchParams = urlParams.toString();
        console.log('Form-based search params:', searchParams);
      } else {
        console.log('No form found, falling back to URL params');
        // Fallback to URL method
        const currentUrl = new URL(window.location.href);
        const currentParams = currentUrl.searchParams;

        // Build new search params with current filters + new page
        const newParams = new URLSearchParams();

        // Copy all current parameters except page
        currentParams.forEach((value, key) => {
          if (key !== 'page') {
            newParams.append(key, value);
          }
        });

        // Add the new page parameter
        if (pageParam) {
          newParams.append('page', pageParam);
        }

        searchParams = newParams.toString();
      }

      console.log('Final search params for pagination:', searchParams);

      // Render the page with the new parameters
      FacetFiltersForm.renderPage(searchParams, e, true); // Update URL for pagination

      return false;
    } else {
      console.log('Pagination link missing data-page attribute');
    }
  }
}, true); // Use capture phase to ensure we catch it first